var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.bemBlock,
        { "the-search--show": _vm.visible },
        { "interaction-active": _vm.interacting }
      ],
      attrs: { id: "vuethesearch" },
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.hide($event)
        }
      }
    },
    [
      _c("TheSearchForm", {
        ref: "form",
        class: _vm.bemElement("form"),
        attrs: {
          "autocomplete-source": _vm.autocompleteSource,
          results: _vm.results,
          "search-source": _vm.searchSource
        },
        on: { searched: _vm.searchedHandler },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      }),
      _vm._v(" "),
      _c("BaseImageSearchPreview"),
      _vm._v(" "),
      _vm.showResultTitle
        ? _c("p", { class: _vm.bemElement("results-title") })
        : _vm._e(),
      _vm._v(" "),
      _vm.visible
        ? _c("BaseProductGrid", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.products && _vm.products.length > 0,
                expression: "products && products.length > 0"
              }
            ],
            ref: "grid",
            class: [
              _vm.bemElement("results"),
              {
                "u-scrollbar-byl": !_vm.infiniteScrollWrapper,
                "searched-animation": _vm.showSearchAnimation
              }
            ],
            attrs: {
              products: _vm.products,
              type: "search",
              "infinite-wrapper": _vm.infiniteScrollWrapper,
              "infinite-next": true
            },
            on: {
              "infinite:next": _vm.fetchNextPage,
              mounted: _vm.initScrollMonitoring,
              "open-pdp-modal": _vm.openModal
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("ThePDPModal", {
        attrs: { "product-tile": _vm.productForQuickview },
        on: { closed: _vm.closeModal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }